import axios from 'axios';
import { API } from '../../constants';
import { replace as ReplaceRouter } from 'connected-react-router';
import _ from 'lodash';
import { UserGetPurchaseOrderByUserId } from '../actions';

const createAction = (name) => ({
  GET_ITEM_BY_ID_PENDING: `${name}_GET_ITEM_BY_ID_PENDING`,
  GET_ITEM_BY_ID_SUCCESS: `${name}_GET_ITEM_BY_ID_SUCCESS`,
  GET_ITEM_BY_ID_FAILED: `${name}_GET_ITEM_BY_ID_FAILED`,
  OPEN_DIALOG_PRODUCT_OVER_STOCK: `${name}_OPEN_DIALOG_PRODUCT_OVER_STOCK`,
  CLOSE_DIALOG_PRODUCT_OVER_STOCK: `${name}_CLOSE_DIALOG_PRODUCT_OVER_STOCK`,
  OPEN_DIALOG_PRODUCT_REVIEW: `${name}_OPEN_DIALOG_PRODUCT_REVIEW`,
  CLOSE_DIALOG_PRODUCT_REVIEW: `${name}_CLOSE_DIALOG_PRODUCT_REVIEW`,
  CLEAR: `${name}_CLEAR`,
  ASSIGN_CATEGORY: `${name}_ASSIGN_CATEGORY`,

  // GET_REVIEW_PENDING: `${name}_GET_REVIEW_PENDING`,
  // GET_REVIEW_SUCCESS: `${name}_GET_REVIEW_SUCCESS`,
  // GET_REVIEW_FAILED: `${name}_GET_REVIEW_FAILED`,

  ADD_REVIEW_PENDING: `${name}_ADD_REVIEW_PENDING`,
  ADD_REVIEW_SUCCESS: `${name}_ADD_REVIEW_SUCCESS`,
  ADD_REVIEW_FAILED: `${name}_ADD_REVIEW_FAILED`
});

export const PRODUCT = createAction('PRODUCT');

export const getItemById = (itemName, type) => async (dispatch, getState) => {
  dispatch(ClearProduct());
  dispatch({ type: PRODUCT.GET_ITEM_BY_ID_PENDING });
  try {
    const { language, login } = getState();
    const { currentLanguage, basenameURL } = language;

    let customerIdParam = '';
    if (login.firebaseAuth && login.firebaseAuth.uid) {
      customerIdParam = `?customerId=${login.firebaseAuth.uid}`;
    }

    let url =
      type === "voucher"
        ? `${API.GET_VOUCHER_EACH_ITEM}${itemName}`
        : `${API.PRODUCT_BY_MODEL}${itemName}${customerIdParam}`;

    const result = await axios
      .get(`${url}`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': currentLanguage
        }
      })
      .then((res) => res.data)
      .catch((error) => Promise.reject(error));

    const Item = result.name;

    if (type !== 'buyAgain') {
      const newPathName = `${basenameURL}/${type}/${Item.split(' ').join('-')}`;
      dispatch(ReplaceRouter(newPathName));
    }

    dispatch({
      type: PRODUCT.GET_ITEM_BY_ID_SUCCESS,
      payload: result
    });
  } catch (error) {
    dispatch({
      type: PRODUCT.GET_ITEM_BY_ID_FAILED,
      error
    });
  }
};

// export const getItemReview = (itemId) => async (dispatch, getState) => {
//   dispatch({ type: PRODUCT.GET_REVIEW_PENDING });
//   try {
//     const { language, login } = getState();
//     const { currentLanguage, basenameURL } = language;

//     // const result = await axios
//     //   .get(`${API.GET_PRODUCT_REVIEW}/${itemId}`, {
//     //     headers: {
//     //       'Content-Type': 'application/json',
//     //       'Accept-Language': currentLanguage
//     //     }
//     //   })
//     //   .then((res) => res.data)
//     // .catch((error) => Promise.reject(error));

//     const result = [
//       {
//         customerId: login.firebaseAuth.uid,
//         point: 5,
//         comment: 'ssadsad'
//       }
//     ];

//     if (result && result.length > 0) {
//       dispatch({
//         type: PRODUCT.GET_REVIEW_SUCCESS,
//         payload: result
//       });
//     } else {
//       dispatch({
//         type: PRODUCT.GET_REVIEW_FAILED,
//         error: 'getItemReviewFail'
//       });
//     }
//   } catch (error) {
//     dispatch({
//       type: PRODUCT.GET_REVIEW_FAILED,
//       error
//     });
//   }
// };

const validationAdd = (form) => {
  return !form.rating ? false : true;
};

export const AddItemReview = (form) => async (dispatch, getState) => {
  dispatch({ type: PRODUCT.ADD_REVIEW_PENDING });
  if (await validationAdd(form)) {
    try {
      const { language, login } = getState();
      const { currentLanguage } = language;
      var formdata = new FormData();
      await formdata.append('ItemOrderId', form.product.id);
      await formdata.append('Comment', form.review);
      await formdata.append('Point', form.rating);

      (await form.picture) &&
        form.picture.length > 0 &&
        form.picture.forEach(async (file, index) => {
          await formdata.append('Images', file);
        });

      const result = await axios
        .post(API.POST_PRODUCT_REVIEW, formdata, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept-Language': currentLanguage
          }
        })
        .then((res) => res.status)
        .catch((error) => Promise.reject(error));

      if (result === 200) {
        dispatch({
          type: PRODUCT.ADD_REVIEW_SUCCESS
        });
        dispatch(CloseDialogProductReview());
        dispatch(UserGetPurchaseOrderByUserId());
      } else {
        dispatch({
          type: PRODUCT.ADD_REVIEW_FAILED,
          error: result
        });
        dispatch(CloseDialogProductReview());
      }
    } catch (error) {
      dispatch({
        type: PRODUCT.ADD_REVIEW_FAILED,
        error
      });
      dispatch(CloseDialogProductReview());
    }
  } else {
    dispatch({
      type: PRODUCT.ADD_REVIEW_FAILED,
      error: 'emptyField'
    });
  }
};

export const OpenDialogProductOverStock = () => (dispatch) => {
  dispatch({ type: PRODUCT.OPEN_DIALOG_PRODUCT_OVER_STOCK });
};

export const CloseDialogProductOverStock = () => (dispatch) => {
  dispatch({ type: PRODUCT.CLOSE_DIALOG_PRODUCT_OVER_STOCK });
};

export const OpenDialogProductReview = () => (dispatch) => {
  dispatch({ type: PRODUCT.OPEN_DIALOG_PRODUCT_REVIEW });
};

export const CloseDialogProductReview = () => (dispatch) => {
  dispatch({ type: PRODUCT.CLOSE_DIALOG_PRODUCT_REVIEW });
};

export const ClearProduct = () => (dispatch) => {
  dispatch({ type: PRODUCT.CLEAR });
};

export const AssignCategory = (category) => (dispatch) => {
  dispatch({
    type: PRODUCT.ASSIGN_CATEGORY,
    payload: category
  });
};
